import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Tabs, Tab, Box, Button, Typography } from '@mui/material';
import { ProductList } from '../components/ProductList';
import ListManager from '../components/lists/ListManager';
import { useAuth } from '../contexts/AuthContext';

const FavoritesPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Apply id to body for page-scoped styling
  useEffect(() => {
    const prevId = document.body.id;
    document.body.id = 'fav-page';
    return () => {
      document.body.id = prevId;
    };
  }, []);

  if (!isAuthenticated) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Sign in to view your favorites and lists
        </Typography>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => navigate('/login', { state: { from: '/favorites' } })}
          sx={{ mt: 2 }}
        >
          Sign In
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Tabs 
        className="favorites-tabs"
        value={tabValue} 
        onChange={handleTabChange} 
        aria-label="favorites tabs"
        sx={{ mb: 3 }}
      >
        <Tab className="fav-tab" label="My Favorites" />
        <Tab className="list-tab" label="My Lists" />
      </Tabs>
            
      {tabValue === 0 && (
        <Box>
          <ProductList favoritesOnly={true} />
        </Box>
      )}
      
      {tabValue === 1 && (
        <Box>
          <ListManager />
        </Box>
      )}
    </Container>
  );
};

export default FavoritesPage;
